module.exports = function(tokens) {
  return {
    dividerColor: tokens.themeBorderSecondaryDefault,
    dividerSizeSmall: 1,
    dividerSizeMedium: 2,
    dividerSizeLarge: 4,
    dividerSizeXlarge: 8
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/component/divider.js
// module id = 358
// module chunks = 0